var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import '@styles/webdesktop/stylesheets/typography.scss';
import React from 'react';
import { Typography } from '../Typography/Typography';
import { TextColor, TextState } from './TextColor';
export const Label = (_a) => {
    var { color = TextColor.OnSurface, state = TextState.Default } = _a, restProps = __rest(_a, ["color", "state"]);
    const typographyClassNames = [`colored typography-${color}`, state === TextState.Default ? '' : ` ${state}`];
    const typographyClassName = typographyClassNames.filter(Boolean).join(' ');
    return React.createElement(Typography, Object.assign({}, restProps, { className: typographyClassName }));
};
